<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 19:13:36
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->


<template>
    <div style="padding: 20px 0px 0px 20px;">
        <h2>小程序版本管理</h2>

        <div style="margin-top: 20px; text-align: start;">
            版本号: <el-input size="small" v-model="version" placeholder="版本号" style="width: 350px; margin-right: 20px;"></el-input>
            <el-button size="small" type="primary" @click="addVersion">保存</el-button>  
        </div>
  
    </div>
  </template>
  
  
  <script>
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import { handleStudent, handleTeacher } from "../utils/publicInterface";
  import { getStudentsType } from "@/api/fiveClassApi"
  import { getTeachers } from "@/api/fiveClassApi"
  import { ApiGetStudentList, } from "@/api/apiTask";
  import { getSubject } from "@/api/fiveClassApi"

  export default {
    components:{
  
    },
    data() {
        return{
           version: '',
           versionRow: null,
        }
    },
  
    mounted(){
        this.GetVersion()
    },
  
  
    methods:{

        GetVersion(){
            let data = { "dictCode":"小程序版本号", "pageNo":"1", "pageSize":"10" }
            axios.post(`${apiBaseUrl}/dict/getDictList`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if(res.data.code === 200){
                    if(res.data && res.data.data && res.data.data.records.length > 0){
                        let version = res.data.data.records[0]
                        this.versionRow = version
                        this.version = version.dictValue
                    }
                     this.$message.success(res.data.message || '获取成功')
                } else {
                    this.$message.error(res.data.message || '获取失败')
                }
            }).catch(err => {
                this.$message.error(err.message || '获取失败')
            })
        },
        
        addVersion(){
            let data = {  id: this.versionRow.id, dictValue: this.version, }
            axios.put(`${apiBaseUrl}/dict/editDict`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if(res.data.code === 200){
                    this.$message.success('保存成功')
                    this.GetVersion()
                } else {
                    this.$message.error(res.data.message || '保存失败')
                }
            }).catch(err => {
                this.$message.error(err.message || '保存失败')
            })
        },
  
        
    }
  
  }
  </script>
  
  
  <style scoped lang="less">
  
 
  
  </style>
  


// WEBPACK FOOTER //
// src/WxMiniProgram/WxMiniProgram.vue